import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      <p className="footer-copy">
        © 2025 Stéphane Mbangossoum — Ingénieur SysOps · Cloud · DevOps
      </p>
      <div className="footer-links">
        <a href="https://github.com/nadjial" target="_blank" rel="noreferrer" aria-label="GitHub">
          <GitHubIcon />
        </a>
        <a
          href="https://www.linkedin.com/in/st%C3%A9phane-mbangossoum-221609198/"
          target="_blank"
          rel="noreferrer"
          aria-label="LinkedIn"
        >
          <LinkedInIcon />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
